const api = {
  agentSearchTerm(searchTerm) {
    return `/agents/search/searchTerm=${searchTerm}`;
  },
  agentSearch() {
    return "/agents/search";
  },
  agentCreate() {
    return "/agents/agent";
  },
  agentGet(id) {
    return `/agents/agent/${id}`;
  },
  agentUpdate(agentInfo) {
    return `/agents/agent/${agentInfo.id}`;
  }
};

export default api;